import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import useRippleEffect from '../hooks/useRippleEffect';
// CSS
import '../assets/css/product-card.css';
// Images
import { Link } from 'react-router-dom';

export default function ProductCard(props) {
  const [inCart, setInCart] = useState(props.inCart);

  useRippleEffect();

  // Handle Ratings
  const [rating, setRating] = useState(props.rating);
  
  useEffect(() => {
    
  }, [])

  return (
    <div className="product_card">
      <div className="thumbnail">
        <img src={props.thumbnail} alt="Product Thumbnail" />
      </div>
      <div className="product_name">{props.name}</div>
      <div className='d_flex js_space al_center w_100'>
        <div className="price">
          <div className="discount_price">{props.discountPrice} <span>&#2547;</span></div>
          <div className="main_price">{props.mainPrice} {props.mainPrice? <span>&#2547;</span> : <></>}</div>
        </div>
        <div className="actions">
          {/* <Link to="/by-product?id=abc" className="btn_primary ripple-animate ripple-dark bg-1">Purchase</Link> */}
          <button className="btn_primary ripple-animate ripple-light cart_btn"><span className="fab fa-opencart"></span></button>
        </div>
      </div>
    </div>
  )
}
